<template>
    <div>
        <data-grid
            class="transaction-list"
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :headerMessage="getHeaderMessage()"
            :actions="actions"
            :hideHeader="true"
            :hideActions="false"
            :selectionEnabled="false"
            :beforeSetupGrid="beforeSetupGrid"
            :onLoaded="onLoaded"
            :perPage="10"
            :sortOptions="{
                enabled: true,
                field: 'date',
                type: 'desc',
            }"
            :expandedOptions="{
                enabled: true,
                template: 'transaction-details-view',
            }"
        ></data-grid>
        <v-dialog v-model="newTransactionDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">New Transaction</v-card-title>
                <v-menu
                    v-model="newTransaction.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class="px-3"
                            v-model="newTransaction.date"
                            :value="newTransaction.date"
                            label="Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="newTransaction.date"
                    ></v-date-picker>
                </v-menu>
                <v-select
                    class="px-3"
                    :items="['Debit', 'Credit']"
                    label="Type"
                    v-model="newTransaction.type"
                    ref="type"
                ></v-select>
                <v-combobox
                    class="px-3"
                    label="Category"
                    :items="transactionCategories"
                    v-model="newTransaction.category"
                ></v-combobox>
                <v-text-field
                    class="px-3"
                    label="Description"
                    v-model="newTransaction.description"
                ></v-text-field>
                <v-text-field
                    class="px-3"
                    type="number"
                    label="Amount"
                    v-model="newTransaction.amount"
                ></v-text-field>
                <v-combobox
                    class="px-3"
                    label="Payment Method"
                    :items="paymentMethods"
                    v-model="newTransaction.paymentMethod"
                ></v-combobox>
                <v-select
                    class="px-3"
                    label="Card Type"
                    :items="['Visa', 'Amex']"
                    clearable
                    v-model="newTransaction.cardType"
                ></v-select>
                <v-text-field
                    class="px-3"
                    label="Card Ending"
                    v-model="newTransaction.cardEnding"
                ></v-text-field>
                <v-text-field
                    class="px-3"
                    label="Check Number"
                    v-model="newTransaction.checkNumber"
                ></v-text-field>
                <v-text-field
                    class="px-3"
                    label="Reference Number"
                    v-model="newTransaction.referenceNumber"
                ></v-text-field>
                <v-card-actions class="mr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="newTransactionDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { formatPhoneNumber, formatCurrency } from "../utils/helpers.js";
import moment from "moment";

export default {
    props: {
        propertyID: Number,
        property: Object,
    },
    data() {
        return {
            url: "",
            loading: true,
            processing: false,
            calls: [],
            transactions: [],
            paymentMethods: [],
            transactionCategories: [],
            newTransactionDialog: false,
            pagination: {
                totalCount: 0,
                rowsPerPage: 5,
                page: 1,
            },

            newTransaction: {
                date: "",
                datePickerMenu: false,
                type: "Debit",
                description: "",
                amount: "",
                checkNumber: "",
                paymentMethod: "",
                cardType: "",
                cardEnding: "",
                referenceNumber: "",
                category: "",
            },

            title: "Transactions",

            actions: [],
            propertyDetails: "",

            columns: [
                {
                    field: "type",
                    isIcon: true,
                    icon: (value) => {
                        if (!value) return "";

                        switch (value.toUpperCase()) {
                            case "CREDIT":
                            case "DEBIT":
                                return "mdi-currency-usd";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value) => {
                        if (!value) return "";

                        switch (value.toUpperCase()) {
                            case "CREDIT":
                                return "success";
                            case "DEBIT":
                                return "rgb(243, 81, 35)";
                            default:
                                return "#aeb8bf";
                        }
                    },
                },
                {
                    sortable: true,
                    label: "Date",
                    field: "date",
                    type: "date",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Description",
                    field: "description",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Type",
                    field: "type",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Category",
                    field: "category",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Amount",
                    field: "amount",
                    type: "Number",
                    hidden: false,
                    formatFn: (value) => {
                        return formatCurrency(value);
                    },
                    tdClass: (row) => {
                        return row.type == "Debit"
                            ? "text-danger"
                            : "text-success";
                    },
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Payment Method",
                    field: "paymentMethod",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Card Ending",
                    field: "cardEnding",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Card Type",
                    field: "cardType",
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Check Number",
                    field: "checkNumber",
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Ref #",
                    field: "referenceNumber",
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
            ],
        };
    },
    async created() {
        // await this.loadIvrCalls();
        this.actions.push({
            text: "New Transaction",
            action: this.openTransactionDialog,
        });

        this.loadPaymentMethods();
        this.loadTransactionCategories();
    },
    watch: {},
    mounted() {},
    beforeDestroy() {},
    computed: {},
    methods: {
        openTransactionDialog() {
            this.newTransactionDialog = true;
        },
        beforeSetupGrid() {
            this.url = "transactions?propertyID=" + this.propertyID;

            this.loadProprtyDetails();
        },
        async loadProprtyDetails() {
            const property = await this.$http.get(
                "api/Properties/GetProperty?id=" + this.$route.params.id
            );

            this.propertyDetails = property;
        },
        async loadPaymentMethods() {
            this.paymentMethods = await this.$http.get(
                "api/transactions/getPaymentMethods"
            );
        },
        async loadTransactionCategories() {
            this.transactionCategories = await this.$http.get(
                "api/transactions/getTransactionCategories"
            );
        },
        getHeaderMessage() {
            if (!this.propertyDetails) return "";

            return `Debit:
                <span style="font-weight: 500; margin-right: 8px; color: rgb(243, 81, 35)">${formatCurrency(
                    this.propertyDetails.debit
                )}</span>
                   Credit:
                <span style="font-weight: 500; margin-right: 8px; color: #5cb860">${formatCurrency(
                    this.propertyDetails.credit
                )}</span>
                   Construction:
                <span style="font-weight: 500; color: rgb(243, 81, 35)">${formatCurrency(
                    this.propertyDetails.constructionSpent
                )}</span>`;
        },
        onLoaded(rows) {
            this.loadProprtyDetails();
        },
        async save() {
            const data = this.newTransaction;

            data.propertyID = this.propertyID;

            this.processing = true;

            await this.$http.post("api/transactions/save", {
                transaction: data,
                details: [],
            });

            this.processing = false;
            this.newTransactionDialog = false;
            this.$refs.grid.load();
        },
        getTotalCount() {
            if (this.$refs && this.$refs.grid) {
                return this.$refs.grid.pagination.totalCount;
            }

            return 0;
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.calls = this.ivrCalls.slice(
                number,
                number + this.pagination.rowsPerPage
            );
        },
        formatPhoneNumber(number) {
            return formatPhoneNumber(number);
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
        getTransactions() {
            return this.transactions;
        },
    },
};
</script>
<style>
.ivr-detail-text {
    font-size: 16px;
    font-weight: 400;
}
.transaction-list.container {
    padding-right: 0px !important;
    padding-left: 0px !important;
}
.transaction-list .v-card__text {
    padding-top: 0px !important;
}
</style>
